export default function useMortgage() {
    function getMonthlyInstallments(loanAmount, loanx, monthlyInterest) {
        return (loanAmount * loanx * monthlyInterest) / (loanx - 1);
    }

    function getMonthlyInterest(interestRate) {
        return interestRate / 100 / 12;
    }

    function getLoanTermMonths(loanTenure) {
        return loanTenure * 12;
    }

    function getLoanX(monthlyInterest, loanTermMonths) {
        return Math.pow(1 + monthlyInterest, loanTermMonths);
    }

    function getAdvancePayment(advancePercentage, interestedLoanAmount) {
        if (advancePercentage !== null) {
            return (advancePercentage / 100) * interestedLoanAmount;
        }

        return 0;
    }

    function getTotalInterest(monthlyInstallments, loanTermMonths, creditedAmount) {
        return Math.round(monthlyInstallments * loanTermMonths - creditedAmount);
    }

    return {
        getLoanX,
        getTotalInterest,
        getLoanTermMonths,
        getAdvancePayment,
        getMonthlyInterest,
        getMonthlyInstallments,
    };
}
